import { render, staticRenderFns } from "./TabelaPorcentagem.vue?vue&type=template&id=ec35edca&scoped=true"
import script from "./TabelaPorcentagem.vue?vue&type=script&lang=js"
export * from "./TabelaPorcentagem.vue?vue&type=script&lang=js"
import style0 from "./TabelaPorcentagem.vue?vue&type=style&index=0&id=ec35edca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec35edca",
  null
  
)

export default component.exports